import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import HomeTitle from '../components/HomeTitle/HomeTitle';
import Table from "../components/Table/Table"
import axios from 'axios';

function Forms() {
    const userinfo = useSelector((state) => state.auth);
    const { currentLocal } = useSelector((state) => state.currentLocal);
    const [items, setItems] = useState([])
    // const updatedPayments = userinfo?.userArray?.user?.student?.student_fees.map((item, index) =>
    //     index === 0 ? { ...item, name: "دفع استمارة التسجيل" } : item
    // );
const [updatedPayments, setUpdatedPayments] = useState([])
    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.receipt,
        currentLocal.home.namePlaceholder,
        currentLocal.home.method,
        currentLocal.home.status,


    ]
                const getAllApis = async () => {

            await axios
                .post(`https://nanosoft.space/taarteb/public/api/user/auth/me`,{}, {
                    headers: {
                        Authorization: `Bearer ${userinfo.userArray.access_token}`
                    }
                })
                .then(async (res) => {
    const updatedPayments = res.data.data?.student?.student_fees.map((item, index) =>
        index === 0 ? { ...item, name: "دفع استمارة التسجيل" } : item
    );
    setUpdatedPayments(updatedPayments)

                })
                .catch((error) => {

                    



                });

        }
        const getforms=async()=>{
                try {
      const response = await axios.get(
        "https://nanosoft.space/taarteb/public/api/admin/student-fees",
        {
          headers: {
            Authorization: `Bearer ${userinfo.userArray.access_token}`,
          },
        }
      );
      setUpdatedPayments(response.data.data);

    } catch (error) {
      console.log(error);
    }
        }
    useEffect(() => {
if(localStorage.getItem("type")== "student"){
        getAllApis()

}else{
getforms()

}
    }, [])
    return (
        <div className="px-0 my-3 w-100 dashboard_content">
            <Container>
                <div className="d-flex flex-column w-100">

                    <AuthNavbar />
                </div>
                <div className="mt-5 mx-3">
                    <HomeTitle title={currentLocal.home.forms} />
                    <Table
                        data={updatedPayments}
                        headerIterm={headerIterm}
                        pdf={userinfo?.userArray?.user?.student?.application_form}
                          actions={localStorage.getItem("type") !== "student"? ["acceptOrReject"] : [""]}
acceptStatus={'student-fees'}

                    // onDataChanged={getAllApis}
                    />

                </div>
            </Container>
        </div>
    )
}

export default Forms